import { rem } from 'polished';
import styled from 'styled-components';

export const StyledListingDocumentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem('32px')};
  border-radius: ${rem('10px')};
  padding: ${rem('20px')} ${rem('24px')};
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
`;

export const StyledLabel = styled.h2`
  font-size: ${rem('16px')};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.cross.black};
  margin-bottom: ${rem('9px')};
`;
